import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { requestInstallWorkorderReport, clearInstallWorkorderReport } from 'actionCreators';
import { getWorkroomFilteredByIds } from '../../../../../reducers';
import {
  queryParamStringsToIntArray,
  queryParamToArray,
  isParamToAdjust,
  reassignQueryProps,
} from '../../../../../utils/validationUtils';
import Loading from 'components/Loading';
import PageActionBar from 'components/PageActionBar';
import InstallWorkorderFilters from 'InstallWorkorderFilters';
import InstallWorkorderHeader from 'InstallWorkorderHeader';
import InstallWorkorderTable from 'InstallWorkorderTable';
import contentAreaStyles from 'styles/contentArea';
import S from 'styles.scss';

class InstallWorkorderReport extends React.Component {
  componentDidMount = () => {
    const { location: { search, query } } = this.props;
    this.props.clearInstallWorkorderReport();
    if (search) {
      const adjustedQuery = this.adjustWorkroomsAndSurfaceTypeParams(query || {});
      this.props.requestInstallWorkorderReport(adjustedQuery);
    }
  }

  componentWillReceiveProps = (nextProps) => {
    const { location: { search, query } } = nextProps;
    if (search !== this.props.location.search) {
      if (search) {
        const adjustedQuery = this.adjustWorkroomsAndSurfaceTypeParams(query || {});
        this.props.requestInstallWorkorderReport(adjustedQuery);
      } else this.props.clearInstallWorkorderReport();
    }
  }

  componentWillUnmount = () => this.props.clearInstallWorkorderReport();

  adjustWorkroomsAndSurfaceTypeParams = (query) => {
    const adjustWorkrooms = isParamToAdjust(query, 'workrooms');
    const adjustSurfaceTypes = isParamToAdjust(query, 'surface_types');
    if (!adjustWorkrooms && !adjustSurfaceTypes) return query;
    const fields = [];
    const vals = [];
    if (adjustWorkrooms) {
      fields.push('workrooms');
      vals.push(queryParamToArray(query.workrooms));
    }
    if (adjustSurfaceTypes) {
      fields.push('surface_types');
      vals.push(queryParamToArray(query.surface_types));
    }
    return reassignQueryProps(query, fields, vals);
  }

  render = () => {
    const { location, report: { loading, loaded, data } } = this.props;
    return (<div>
      <PageActionBar
        showAdd={false}
        showFiltersBtn={false}
        title="Install/Workorder Report"
      />
      <div className={contentAreaStyles.contentAreaContainer}>
        <div className={`${contentAreaStyles.contentArea} ${S.noPrint}`}>
          <InstallWorkorderFilters location={location} />
        </div>
        {loaded && <div className={`${contentAreaStyles.contentArea} ${S.tableContainer}`}>
          <InstallWorkorderHeader
            workrooms={location.query.workrooms}
            resultCount={data.length}
          />
          <InstallWorkorderTable workrooms={location.query.workrooms} />
        </div>}
        {loading && <Loading />}
      </div>
    </div>);
  }
}

InstallWorkorderReport.propTypes = {
  location: PropTypes.shape({
    query: PropTypes.objectOf(PropTypes.string).isRequired,
    search: PropTypes.string.isRequired,
  }).isRequired,
  report: PropTypes.shape({
    loaded: PropTypes.bool,
  }),
  requestInstallWorkorderReport: PropTypes.func.isRequired,
  clearInstallWorkorderReport: PropTypes.func.isRequired,
};

export default connect((state, ownProps) => {
  const workrooms = queryParamStringsToIntArray(ownProps.location.query.workrooms || []);
  return ({
    report: state.reports.installWorkorder,
    workrooms: getWorkroomFilteredByIds(state)(workrooms || []),
  });
}, { requestInstallWorkorderReport, clearInstallWorkorderReport })(InstallWorkorderReport);



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/reports/installWorkorderReport/index.jsx